import {
    upload, getMyProject
} from '@/api/upload'
import { Toast } from 'vant';
import { Dialog } from 'vant';


export default {
    name: 'upload',
    data() {
        return {
            courseList: [{
                    id: 7,
                    name: 'Creative Handcraft Course 创意手工制作'
                },
                {
                    id: 8,
                    name: 'Drawing 绘画',
                },
                {
                    id: 9,
                    name: 'Calligraphy 书法',
                },
                {
                    id: 10,
                    name: 'Creative Short Video 创意短视频',
                },
            ],
            fileList: [],
            form: {
                uploadpath: '',
                type: '',
                course_id: '',
                name: '',
                desc: '',
                state: '',
            },
            hasProject: false,
            state: null,
            fileRead: false,

            fileAdded: true,
            options: {
                // https://github.com/simple-uploader/Uploader/tree/develop/samples/Node.js
                target: 'https://activity.sznews.com/2021/pshy.php?s=index/upload/uploadChunks',
                testChunks: false,

                chunkSize: '4096000',   //分块大小
                fileParameterName: 'file', //上传文件时文件的参数名，默认file
                maxChunkRetries: 3,  //最大自动失败重试上传次数
                simultaneousUploads: 1,
            },
            attrs: {
                accept: 'video/*',
                multiple: false
            }
        }
    },

    computed: {
        courseName() {
            const that = this;
            let courseName = '';
            that.courseList.forEach(item => {
                if (item.id == that.$route.query.id) {
                    courseName = item.name
                }
            })
            return courseName
        },
    },

    methods: {

        onTouch(state) {
            const that = this;

            // if(!that.fileRead) {

                // return false
            // }

            that.form.state = state;
            if(state == '1') {
                Dialog.confirm({
                    message: '提交后无法修改作品，是否确定提交',
                  })
                    .then(() => {
                      // on confirm
                      that.onSubmit()
                    })
                    .catch(() => {
                      // on cancel
                      that.form.state = null
                      return false
                    });
            }
        },

        onSubmit(values) {
            this.uploadFile()


        },


        uploadFile() {
            let that = this;


            console.log(that.form);
            

            if(that.form.uploadpath) {
                let tmp = that.form.uploadpath.split('.')
                let type = tmp[tmp.length - 1]
                that.form['type'] = type;
            }
            

            let fd = new FormData();
            // fd.append("file", file);
            

            for (let key in that.form) {
                fd.append(key, that.form[key])
            }

            if(!that.hasProject && !that.form.uploadpath) {
                Toast.fail({
                    message: '请添加作品',
                    forbidClick: true
                })
                return false
            }

            Toast.loading({
                message: '作品上传中',
                forbidClick: true,
                duration: 0 
            })

            upload(fd).then(res => {                
                Toast.clear()
                Toast.success({
                    message: res.msg,
                    forbidClick: true,
                    onClose: () => {
                        that.$router.replace('/')
                    }
                })
            }).catch(rej => {
                console.log(rej);

                Toast.fail({
                    message: rej.msg,
                    forbidClick: true,
                    onClose: () => {
                        that.$router.replace('/')
                    }
                })
            })
        },

        afterRead(file) {
            Toast.clear()
            console.log('read finished');
            this.form.file = file.file
            this.fileRead = true;
            // this.uploadFile(file.file)
        },

        // 返回布尔值
        beforeRead(file) {
            if (file.type.indexOf('image') == -1 && file.type.indexOf('video') == -1) {
                Toast('请上传符合格式的文件');
                return false;
            }
            Toast.loading({
                message:'正在添加作品',
                forbidClick: true,
            })
            this.form.type = file.type
            
            return true;
        },

        onOversize(file) {
            console.log(file);
            Toast('文件大小不能超过 50mb');
          },

        getOldMsg() {
            const that = this
            getMyProject({
                course_id: that.form.course_id
            }).then(res => {
                console.log(res);
                if(res.data != null) {
                    that.hasProject = true
                    that.form.name = res.data.project_name
                    that.form.desc = res.data.desc
                    that.form.type = res.data.type
                    that.form.state = res.data.status
                    that.fileList = [{url:'https://activity.sznews.com/front/psxly2021_front/official/static/img/auditing-bg.png'}]
                }else {
                    that.hasProject = false
                    that.fileAdded = false
                }

            }).catch(rej => {
                console.log(rej);
            })
        },

        onFileAdded(file) {
            // this.fileAdded = true
            let type = file.fileType.toLowerCase()
            console.log(type);
            if((type.indexOf('/mp4')==-1) && (type.indexOf('/mov')==-1) && (type.indexOf('/quicktime')==-1)) {
                file.ignored = true
                Toast.fail({
                    forbidClick: true,
                    message: '非法文件操作，请选择正确的文件格式上传'
                    
                })
                return false
            }

            if(file.size > 100 * 1024 * 1024) {
                console.log('超过50M');
                file.ignored = true
                Dialog.alert({
                    message: `
                    <div style="display: flex; flex-direction: column; align-items: center; text-align: center">
                    <p>感谢参与此次活动</p>
                    <p>作品大小仅限100M以内</p>
                    <p>如遇到无法上传等问题</p>
                    <p>请将作品发送至：yuyk@sznews.com</p>
                    <p>并标注用户名与真实姓名</p>
                    <p>我们将有专人与您联系</p>
                  </div>
                    `,
                  }).then(() => {
                    // on close
                  });
            }else {
                console.log('低于50M');
            }

        },

        onFileSuccess(rootFile, file, message) {

            let res = JSON.parse(message)
            if(res.state == 200) {
                Toast.clear()
                console.log(res.msg);
                this.form.uploadpath = res.msg
                Toast('请点击保存或提交')
                this.fileAdded = true
            }
        },

        onFileProgress(rootFile, file, chunk) {
            let progress = parseInt(chunk.uploader.progress() * 100)

            Toast.loading({
                message: '上传中,'+progress+'%',
                forbidClick: true,
                duration: 0
            })
        }
        



    },

    mounted() {
        const that = this;
        that.form.course_id = that.$route.query.id

        that.getOldMsg()


        // const uploaderInstance = this.$refs.uploader.uploader
        // console.log(uploaderInstance);
    },

    created() {

        this.attrs.accept = this.$route.query.uploadtype + '/*'
    }
}